import React from 'react';

const Dashboardpopup = () => {
  return (
    <div className="p-6 text-gray-800">
      <div className="text-4xl mb-4 text-[#3D6643]">📊</div>
      <h2 className="text-2xl font-bold text-[#3D6643] mb-4">Dashboard & Reports</h2>
      <p className="text-sm mb-4">
        Gain full visibility into your villa’s performance with powerful, real-time dashboards and analytics.
      </p>

      <ul className="list-disc list-inside text-sm mb-4 space-y-2">
        <li><strong>Booking Insights:</strong> Monitor current and upcoming reservations at a glance.</li>
        <li><strong>Revenue Reports:</strong> View daily, weekly, and monthly earnings with customizable filters.</li>
        <li><strong>Occupancy Trends:</strong> Analyze villa occupancy rates and spot high/low seasons.</li>
        <li><strong>Graphical Analytics:</strong> Access charts and graphs for a visual breakdown of business metrics.</li>
        <li><strong>Export Options:</strong> Download reports in PDF or Excel format for offline review or sharing.</li>
      </ul>

      <p className="text-sm">
        Make data-driven decisions to improve operations, pricing, and marketing with ease using your personalized dashboard.
      </p>
    </div>
  );
};

export default Dashboardpopup;



